import { render } from "./OrderList.vue?vue&type=template&id=285f63a2&scoped=true"
import script from "./OrderList.js?vue&type=script&lang=js&external"
export * from "./OrderList.js?vue&type=script&lang=js&external"

import "./OrderList.scss?vue&type=style&index=0&id=285f63a2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285f63a2"]])

export default __exports__